import styled from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';

export const VideoBlock = styled.div`
  max-width: ${({ inline }) => (inline ? grid(6) : grid(7))}px;
  margin: 12px auto 36px;
`;

export const VideoBlockInner = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  cursor: pointer;
`;
